import { Column } from 'react-table'
import GetUrls from 'ts/enums/Url'
import { PriceLevel } from 'ts/types/PriceLevel'
import { formatter } from 'utils'
import { Boolean as BooleanCell } from 'components/ui'
import CardTable from 'components/CardTable'
import PriceLevelAddPage from './PriceLevelAddPage'

const columns: Column<PriceLevel>[] = [
  {
    Header: 'ID',
    accessor: 'productPriceLevelId'
  },
  {
    Header: 'Active',
    accessor: 'flActive',
    Cell: ({ value }) => <BooleanCell value={value} />
  },
  {
    Header: 'Price Level Name',
    accessor: 'name'
  },
  {
    Header: 'Last Modified',
    accessor: 'lastModified',
    Cell: ({ value }) => formatter.dateTime(value)
  }
]

const PriceLevelPage = () => {
  const Url = GetUrls();
  return (
  <CardTable
    columns={columns}
    dataKey={Url.getPriceLevel.toString()}
    url={Url.getPriceLevel}
    modalChild={<PriceLevelAddPage />}
  />
)}

export default PriceLevelPage
